import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  SimpleChanges,
  ViewChildren,
  QueryList,

} from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { I2vVideoGridComponent } from '../i2v-video-grid/i2v-video-grid.component';
import { CustomOption } from '../models/IOption';
import { NgxLiveViewService } from '../ngx-live-view.service';

declare var toastr: any;
declare var $: any;
declare var document: any;

export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}
export interface GridElement {
  id: number;
  cameraId: number;
  cameraName: string;
  playbackMode: string;
  time_out: number;
  eventObject: any;
  info: any;
  byAction: any;
  color: string;
  ComponentName: string;
}
@Component({
  selector: 'lib-app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.css'],
})
export class GridComponent implements OnInit, OnDestroy {

  @Input() playDuplicate: boolean = true;
  @Input() gridMode: string = 'general'
  @Input() cameras: any[] = [];
  @Input() idx: string = 'Grid';
  @Input() DataSubject: Subject<any> = {} as Subject<any>;
  @Input() eventDataSubject: Subject<any> = {} as Subject<any>;
  @Input() Rows: number;
  @Input() Cols: number;
  @Input() header: boolean;
  @Input() hideTime: boolean = true;
  @Input() GridConfig: any;
  @Input() RowRatio: number = 1.3;
  @Input() parentHeight: number = 0;
  @Input() parentWidth: number = 0;
  @Input() options: CustomOption[] = [];
  @Input() playerServerIp: string = '';
  @Input() streamerIp: string = '';

  @Output() CloseElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearGrid: EventEmitter<any> = new EventEmitter<any>();
  @Output() NodeDrop: EventEmitter<any> = new EventEmitter<any>();
  @Output() GridArrayChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() playbackModeChangeEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() PlayerNameChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() videoStartEmitterFromGrid: EventEmitter<any> = new EventEmitter<any>();
  @Output() dimensionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseCard: EventEmitter<any> = new EventEmitter<any>();
  @Output() VerifyEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() Minimize: EventEmitter<any> = new EventEmitter<any>();
  @Output() Maximize: EventEmitter<any> = new EventEmitter<any>();
  @Output() FunctionClick: EventEmitter<any> = new EventEmitter<any>();
  @ViewChildren(I2vVideoGridComponent) alerts: QueryList<I2vVideoGridComponent> = {} as QueryList<I2vVideoGridComponent>;

  // Internal Properties

  
  newEntrySubscription: Subscription = {} as Subscription;
  public GridArray: any[] = [];
  id: number = 0;
  row: string = '100%';
  col: string = '33%';
  h: string = '100%';
  edit: boolean = false;
  renderType: string = 'row';
  height: string = '100%';
  rowHeight: string = '1:1';
  rowsArray: any[] = ['100%', '100%', '100%'];
  colsArray: any[] = ['33%', '33%', '33%'];
  numbers: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  selectedGridElements: any = [];
  gridFullScreen: boolean = false;
  GridParentDivHeight = 'calc(100vh - 160px)';
  queueLimit: number = 4;

  constructor(private _NgxLiveViewService: NgxLiveViewService) {
    this.GridArray = ['', '', ''];
    this.Rows = 1;
    this.Cols = 3;
    this.header = true;
    this.row = '100%';
    this.col = '33%';

    /* Adding an event listener to the fullscreenchange event for Video Grid and Open Sea Dragon */
    addEventListener('fullscreenchange', event => {
      try {
        const elem = <HTMLElement>(
          document.querySelector('.openseadragon-container')
        );
        const backButton = <HTMLElement>(
          document.getElementById('openseadragonbackButton')
        );
        if (document.fullscreenElement) {
         this.resizeGrid();
          if (elem) {
            elem.style.zIndex = '10000';
            backButton.style.display = 'none';
          }
        } else {
         this.resizeGrid();
          if (elem) {
            elem.style.zIndex = '0';
            backButton.style.display = 'block';
          }
        }
      } catch (e) {
        console.log(e);
      }
    });

    /* Add an Resizer event whenever screen is resized . Get the width and height of the parent element and then setting the rowHeight property
   of the child component to set the Grid Ratio. */
    addEventListener('resize', event => {
      this.resizeGrid();
    });

    //  add click event listener to mat-grid-tile elements with ctrl key pressed
    document.addEventListener('click', (event: any) => {
      if (
        event.ctrlKey &&
        (event.target.tagName === 'VIDEO' || event.target.tagName === 'IMG')
      ) {
        //this.onCloseCard.emit(event.target.id);
        var id = parseInt(event.target.id.split('_')[1]);
        // get child of element with id grid-tile_+id
        var mat_grid_tile_content_elem = document.getElementById(
          'appWebPlayer_' + id
        );

        // change border color of mat-grid-tile-content element
        // toggle class select
        mat_grid_tile_content_elem.classList.toggle('selected-grid-tile');
        // set border color to red
        if (
          mat_grid_tile_content_elem.classList.contains('selected-grid-tile')
        ) {
          mat_grid_tile_content_elem.style.border = '1px solid red';
          this.selectedGridElements.push(id);
        } else {
          mat_grid_tile_content_elem.style.border = 'none';
          this.selectedGridElements.splice(
            this.selectedGridElements.indexOf(id),
            1
          );
        }
      }
    });
  }

  ngOnInit() {
    //set the this.rowHeight as per parentGrid width and height
    this.rowHeight =
      document.getElementById('parentGrid').offsetWidth / this.Cols +
      ':' +
      document.getElementById('parentGrid').offsetHeight / this.Rows;
    console.log('rowHeight', this.rowHeight, this.Rows, this.Cols);
    this.closeGridCard();
    this.ChangeLayout();
    if (!this.header) {
      this.h = 'Calc(100vh-110px)';
    }
    if (!this.hideTime) {
      this.height = 'Calc(100% - 150px)';
    }

    if (this.DataSubject) {
      this.newEntrySubscription = this.DataSubject.subscribe(item => {
        //used to play nodes on grid when node is dropped on grid as per REC or Live Condition and check for the duplicate nodes
        //console.log(JSON.stringify(item, function (k, v) { return v === undefined ? null : v; }));
        if (item.parentNode == null || item.parentNode == undefined) {
          if (
            item.nodeData.action &&
            item.nodeData.action == 'resource_Acknowledged'
          ) {
            var playingVideoIndex = this.GridArray.findIndex(entry => {
              return (
                (entry.cameraId == item.nodeData.data.data.resourceId ||
                  item.nodeData.data.data.eventProperties
                  ? entry.cameraId ==
                  item.nodeData.data.data.eventProperties.Mapped_Camera_Id
                  : entry.cameraId == item.nodeData.data.data.resourceId) &&
                entry.eventObject.event_id == item.nodeData.data.data.id
              );
            });
            if (playingVideoIndex > -1) {
              this.GridArray[playingVideoIndex] = '';
            }
          } else if (
            item.nodeData.playbackMode == 'REC' &&
            item.nodeData.byAction
          ) {
            var i = this.GridArray.findIndex(entry => {
              return entry.cameraId == item.nodeData.cameraId &&
                entry.playbackMode == 'REC' &&
                entry.time_out
                ? entry.cameraId == item.nodeData.cameraId &&
                item.nodeData.timeRange.startTime.valueOf() -
                entry.timeRange.startTime.valueOf() <
                entry.time_out * 1000
                : entry.cameraId == item.nodeData.cameraId &&
                item.nodeData.timeRange.startTime.valueOf() -
                entry.timeRange.startTime.valueOf() <
                10000;
            });
            if (i > -1) {
              if (item.nodeData.time_out) {
                if (this.GridArray[i].time_out) {
                  this.GridArray[i].time_out = item.nodeData.time_out + 1;
                } else {
                  this.GridArray[i].time_out = item.nodeData.time_out;
                }
              } else {
                this.GridArray[i].time_out = item.nodeData.time_out;
              }
              this.GridArray[i].eventObject = item.nodeData.eventObject;
              return;
            }
          } else if (item.nodeData.playbackMode == 'REC') {
            var i = this.GridArray.findIndex(entry => {
              return (
                entry.cameraId == item.nodeData.cameraId &&
                entry.playbackMode == 'REC' &&
                item.nodeData.timeRange.startTime.valueOf() ==
                entry.timeRange.startTime.valueOf()
              );
            });
            if (i > -1) {
              toastr.error('Already Playing');
              return;
            }
          }
          this.setElementInGrid(item.nodeData);
        } else {
          //console.log("setelement with parentId : ", item)
          var parentNodeId = 0;
          var containerId = 0;
          if (item.parentNode.includes('grid-tile')) {
            parentNodeId = parseInt(item.parentNode.split('_')[1]);
          } else if (item.parentNode.includes('videoContainer')) {
            var containerId = parseInt(item.parentNode.split('_')[1]);
            parentNodeId = this.GridArray.findIndex(block => {
              return block.id == containerId;
            });
          }
          this.closeElement(containerId);

          //it is for replace the element in grid
          setTimeout(() => {
          this.setElementInGrid(item.nodeData, parentNodeId);
          }, 0);
        }
      });
    }
    if (this.eventDataSubject) {
      this.eventDataSubject.subscribe((data: any) => {
        //If event length increases
          this.GridArray.splice(this.queueLimit-1, 1);
          this.GridArray.unshift(data);
      });
    }

  }

  ngOnDestroy(): void {
    if (this.newEntrySubscription) this.newEntrySubscription.unsubscribe();
  }


  /**
   * The function closeCard() is a function that emits an event called onCloseCard, The event is emitted with the parameter this.idx, which is the index of the card that is being
   * closed from the child component to the parent component.
   */
  closeCard() {
    this.CloseCard.emit(this.idx);
  }


  /**
   * This function sets the grid dimensions and then calls the ChangeLayout() function.
   * @param {number} rows - number, cols: number
   * @param {number} cols - number of columns
   */
  setGridDimensions(rows: number, cols: number) {
    this.Rows = rows;
    this.Cols = cols;
    // this.rowHeight = this.Rows*2+':'+this.Cols;
    this.rowHeight =
      document.getElementById('parentGrid').offsetWidth / this.Cols +
      ':' +
      document.getElementById('parentGrid').offsetHeight / this.Rows;
    this.ChangeLayout();
  }

  /**
   * If the item is a video, and the item is live, and the item is not already present, and the grid is not
   * full, then add the item to the grid.
   * @param {GridElement} item - GridElement - this is the object that is being dragged.
   * @param {string} [parentNode] - The id of the element that the user dropped the item on.
   */
  setElementInGrid(item: GridElement, parentNode?: number) {
    //console.log("parentNode in Set Element :", parentNode, item);
    if (parentNode == undefined || parentNode == null) {
      if (item && item.ComponentName == 'Video') {
        if (item.playbackMode == 'LIVE') {
          var numberofentries = this.GridArray.filter(entry => {
            return (
              entry.cameraId == item.cameraId && entry.playbackMode == 'LIVE'
            );
          });
          if (numberofentries.length > 0 && !this.playDuplicate) {
            this._NgxLiveViewService.notificationemittor.next({
              source: 'Video-Grid',
              message: 'Live View is Already Running!!',
              event: item,
            });
            console.log('Live View is Already Running!!');
          } else if (item.time_out) {
            var index = this.GridArray.findIndex(entry => {
              return (
                entry.cameraId == item.cameraId && entry.playbackMode == 'LIVE'
              );
            });

            if (this.GridArray[index].time_out) {
              this.GridArray[index].time_out =
                this.GridArray[index].time_out + 1;
              this.GridArray[index].eventObject = item.eventObject;
            }
          } else {
            var i = this.GridArray.findIndex(block => {
              return block == '';
            });
            if (i > -1) {
              this.GridArray[i] = item;
              this.GridArrayChanged.emit({
                operation: 'add',
                id: this.idx,
                position: i,
              });
            } else {
              this._NgxLiveViewService.notificationemittor.next({
                source: 'Video-Grid',
                message: 'Please Increase Grid Size',
                event: item,
              });
              //console.log('Please Increase Grid Size');
            }
          }
        } else {
          var i = this.GridArray.findIndex(block => {
            return block == '';
          });
          if (i > -1) {
            this.GridArray[i] = item;
            this.GridArrayChanged.emit({
              operation: 'add',
              id: this.idx,
              position: i,
            });
          } else {
            this._NgxLiveViewService.notificationemittor.next({
              source: 'Video-Grid',
              message: 'Please Increase Grid Size',
              event: item,
            });
            console.log('Please Increase Grid Size');
          }
        }
      } else if (item.ComponentName == 'ExternalApp') {
        var index = this.GridArray.findIndex(entry => {
          return entry.cameraId == item.cameraId;
        });
        if (index < 0) {
          var i = this.GridArray.findIndex(block => {
            return block == '';
          });
          if (i > -1) {
            this.GridArray[i] = item;
            this.GridArrayChanged.emit({
              operation: 'add',
              id: this.idx,
              position: i,
            });
          } else {
            this._NgxLiveViewService.notificationemittor.next({
              source: 'Video-Grid',
              message: 'Please Increase Grid Size',
              event: item,
            });
            console.log('Please Increase Grid Size');
          }
        }
      }
    } else {
      if (!this.playDuplicate) {
        var numberofentries = this.GridArray.filter(entry => {
          return (
            entry.cameraId == item.cameraId && entry.playbackMode == 'LIVE'
          );
        });
        if (numberofentries.length > 0) {
          this._NgxLiveViewService.notificationemittor.next({
            source: 'Video-Grid',
            message: 'Live View is Already Running!!',
            event: item,
          });
          console.log('Live View is Already Running!!');
        } else {
          
          this.GridArray[parentNode] = item;
        }
      } else {
        this.GridArray[parentNode] = item;
      }
    }
  }

    /**
   * The ngOnChanges() function is called whenever a property of the component is changed. 
   * 
   * The function checks if the property that was changed is the gridMode property. If it is, then the
   * GridArray is emptied and the ChangeLayout() function is called to reinitialize the grid array. 

   * @param {SimpleChanges} changes - SimpleChanges
   */
    ngOnChanges(changes: SimpleChanges) {
      for (let propName in changes) {
        if (propName == 'gridMode') {
          this.GridArray = [];
          this.ChangeLayout();
        }
      }
    }
  
  /**
   * Change grid size i.e. change in rows and cols
   * It takes in a number of rows and columns and then creates a grid of that size
   * @param {number} [specialElementNumber] - the index of the element that is special (i.e. the one
   * that is not a square)
   * @param {number} [SErows] - number of rows of the special element
   * @param {number} [SEcols] - number of columns of the special element
   * @param {string} [renderType] - "row" or "column"
   */
  ChangeLayout(
    specialElementNumber?: number,
    SErows?: number,
    SEcols?: number,
    renderType?: string
  ): void {
    this.rowHeight =
      document.getElementById('parentGrid').offsetWidth / this.Cols +
      ':' +
      document.getElementById('parentGrid').offsetHeight / this.Rows;
    //console.log("new ratio is: " + this.rowHeight);
    if (
      specialElementNumber != null &&
      specialElementNumber != undefined &&
      SErows != null &&
      SErows != undefined &&
      SEcols != null &&
      SEcols != undefined
    ) {
      var n = this.Rows * this.Cols - SErows * SEcols + 1;
    } else {
      var n = this.Rows * this.Cols;
    }
    if (renderType) {
      this.renderType = renderType;
    } else {
      this.renderType = 'row';
    }
    var i = 0;
    //used when we increase number of Grids, we first sort vids in ascending order and fill the grid
    if (n > this.GridArray.length) {
      var count = 0;
      this.GridArray.forEach(element => {
        if (element == '' || element == null || element == undefined) {
          this.GridArray.splice(this.GridArray.indexOf(element), 1);
          count++;
        }
      });
      for (i = 0; i < count; i++) {
        this.GridArray.push('');
      }
      for (i = this.GridArray.length; i < n; i++) {
        this.GridArray.push('');
      }
    } else {
      //used when we decrease number of Grids, we first sort vids in ascending order and then maintain number of vids in grid
      var count = 0;
      this.GridArray.forEach(element => {
        if (element == '' || element == null || element == undefined) {
          this.GridArray.splice(this.GridArray.indexOf(element), 1);
          count++;
        }
      });
      for (i = 0; i < count; i++) {
        this.GridArray.push('');
      }
      for (i = this.GridArray.length - 1; i >= n; i--) {
        if (this.GridArray[this.GridArray.length - 1] != '') {
          this.CloseElement.emit(
            this.GridArray[this.GridArray.length - 1].cameraId
          );
        }
        this.GridArray.pop();
      }
    }
    var r: number = 100 / this.Rows;
    this.row = '' + r + '%';
    var c: number = 100 / this.Cols;
    this.col = '' + c + '%';
    this.edit = false;
    this.rowsArray = [];
    this.colsArray = [];
    this.GridArray.forEach((item, index) => {
      if (
        specialElementNumber != null &&
        specialElementNumber != undefined &&
        specialElementNumber == index &&
        SErows != null &&
        SErows != undefined &&
        SEcols != null &&
        SEcols != undefined
      ) {
        this.rowsArray.push(
          '' + Math.floor((100 / this.Rows) * SErows * 10) / 10 + '%'
        );
        this.colsArray.push('' + (100 / this.Cols) * SEcols + '%');
      } else {
        this.rowsArray.push(this.row);
        this.colsArray.push(this.col);
      }
    });
    this.queueLimit = this.Rows * this.Cols;
    //this.dimensionChange.emit({ id: this.idx, data: [this.Rows, this.Cols] });
    this._NgxLiveViewService.notificationemittor.next({
      source: 'Video-grid', 
      message: 'Grid view changed', 
      event:this.GridConfig });
  }

  /**
   * It removes an element from an array and emits the event to parent component for Close Element and Grid Array Changed
   * @param {any} id - the id of the element to be removed
   */
  closeElement(id: any) {
    console.log('close id : ' + id);
    //var s = id.split('_');
    //var elem = this.GridArray[parseInt(s[1])];
    //this.GridArray[parseInt(s[1])] = '';
    var i = this.GridArray.findIndex(item => {
      return item.id == id;
    });
    console.log('index is : ' + i);
    if (i > -1) {
      var elem = this.GridArray[i];
      //var cameraId = this.GridArray[i].cameraId;
      this.GridArray[i] = '';
      this.CloseElement.emit(elem.cameraId);
      this.GridArrayChanged.emit({
        operation: 'remove',
        id: this.idx,
        position: i,
      });
      $(document).ready(() => {
        $('#' + this.idx + '_' + i).droppable({
          accept: '.HomeTree',
          drop: (event: { target: any }, ui: { draggable: any }) => {
            if (ui) {
              var droppable = event.target;
              if (droppable) {
                var gridId = droppable.id;
                var sub = gridId.split('_');
                var gridIndex = parseInt(sub[sub.length - 1]);
                var draggable = ui.draggable;
                if (draggable && draggable.length > 0) {
                  var nodeId = draggable[0].id;
                  var sub = nodeId.split('_');
                  var camid = parseInt(sub[sub.length - 1]);
                  this.onDropByIndex(gridIndex, camid);
                }
              }
            }
          },
        });
      });
    }
  }

  /**
   * If the selectedGridElements array contains the id of the current element in the GridArray, then
   * remove the id from the selectedGridElements array and remove the element from the GridArray.
   * If the selectedGridElements array is empty, then clear the GridArray.
   */
  closeGridCard() {
    let length = this.GridArray.length;
    if (this.selectedGridElements.length == 0) {
      this.clearCard();
    } else {
      for (var i = 0; i < length; i++) {
        //if this.GridArray[i].id exists in selectedGridElements
        if (this.selectedGridElements.indexOf(this.GridArray[i].id) > -1) {
          this.selectedGridElements.splice(
            this.selectedGridElements.indexOf(this.GridArray[i].id),
            1
          );
          this.GridArray[i] = '';
        }
      }
      this.clearGrid.emit();
    }
  }

  /**
   * It clear the Grid Array
   */
  clearCard() {
    for (var i = 0; i < this.GridArray.length; i++) {
      this.GridArray[i] = '';
    }
    this.clearGrid.emit();
  }

   /**
   * If the gridId and camId are both greater than -1, then if the GridArray[gridId] is not empty, emit
   * the GridArray[gridId].cameraId, then find the index of the GridArray that matches the camId, if
   * the index is -1, then find the camera that matches the camId, then set the GridArray[gridId] to
   * the camera, id, camId, cameraName, time_out, playbackMode, ComponentName, selected, playerName,
   * and timeRange, then emit the operation, id, and position, then emit the gridId
   * @param {number} gridId - The index of the grid that the camera is being dropped into.
   * @param {number} camId - number - the id of the camera that was dropped
   */
  onDropByIndex(gridId: number, camId: number) {
    if (gridId > -1 && camId > -1) {
      if (this.GridArray[gridId] != '') {
        this.CloseElement.emit(this.GridArray[gridId].cameraId);
      }
      let index = this.GridArray.findIndex(video => {
        return video.cameraId == camId;
      });
      if (index == -1) {
        var camera = this.cameras.find(x => {
          return x.id == camId;
        });
        this.GridArray[gridId] = {
          camera: camera,
          id: Math.round(Math.random() * 1000),
          cameraId: camId,
          cameraName: camera.resourceName,
          time_out: null,
          playbackMode: 'LIVE',
          ComponentName: 'Video',
          selected: false,
          playerName: '',
          timeRange: undefined,
        };
        this.GridArrayChanged.emit({
          operation: 'add',
          id: this.idx,
          position: gridId,
        });
        this.NodeDrop.emit(gridId);
      } else {
        toastr.error('Live View is Already Running');
      }
    }
  }

 
  /**
   * It plays all the child resources of the node which are droppabe
   * @param {string | any[]} nodes - string | any[]
   */
  playALLChildResources(nodes: string | any[]) {
    var currentIdIndex = 0;
    var len = this.Rows * this.Cols;
    var i = 0;
    while (i != len && currentIdIndex != nodes.length) {
      if (this.GridArray[i] != '') {
        i++;
      } else {
        if (nodes[currentIdIndex].data.isDroppable == false) {
          while (
            nodes[currentIdIndex].data.isDroppable == false &&
            currentIdIndex != nodes.length
          ) {
            currentIdIndex++;
          }
        }
        if (currentIdIndex < nodes.length) {
          var camera = this.cameras.find(x => {
            return x.id == nodes[currentIdIndex].id;
          });
          this.GridArray[i] = {
            camera: camera,
            id: Math.round(Math.random() * 1000),
            cameraId: nodes[currentIdIndex].id,
            cameraName: nodes[currentIdIndex].name,
            time_out: null,
            playbackMode: 'LIVE',
            ComponentName: 'Video',
            selected: false,
            playerName: '',
            timeRange: undefined,
          };
          this.GridArrayChanged.emit({
            operation: 'add',
            id: this.idx,
            position: i,
          });
          this.NodeDrop.emit(nodes[currentIdIndex]);
          currentIdIndex++;
          i++;
        } else {
          break;
        }
      }
    }
  }

  /**
   * Find the index of the object in the array that has a cameraId property that matches the id
   * parameter, and if it exists, remove it from the array.
   * @param {number} id - number - the id of the camera to close
   */
  closeById(id: number) {
    var i = this.GridArray.findIndex(s => s.cameraId == id);
    if (i > -1) {
      this.GridArray[i]='';
    }
  }

  /**
   * It returns the number of occupied grids in the GridArray.
   * @returns The number of occupied grids.
   */
  getNoOfOccupiedGrids() {
    let noOfOccupiedGrid: number = 0;
    if (this.GridArray.length > 0) {
      this.GridArray.forEach(grid => {
        if (grid != '') {
          noOfOccupiedGrid = noOfOccupiedGrid + 1;
        }
      });
    }
    return noOfOccupiedGrid;
  }

  /**
   * When the playerNameChange event is emitted, find the element in the GridArray that matches the id,
   * and set the playerName to the new value and emit an event to parent Component.
   * @param  - { id: any; playerName: any; }
   */
  playerNameChange($event: { id: any; playerName: any }) {
    let id = $event.id;
    let playerName = $event.playerName;
    let elem = this.GridArray.find(s => s.cameraId == id);
    elem.playerName = playerName;
    this.PlayerNameChange.emit({ id: id, playerName: playerName });
  }

  /**
   * "When the video starts, emit an event to the parent component with the id and wmode of the video."
   * @param event - { id: any; wmode: any; }
   */
  onVideoStarted(event: { id: any; wmode: any }) {
    console.log('videoStartEmitterFromGrid');
    let id = event.id;
    let wmode = event.wmode;
    this.videoStartEmitterFromGrid.emit({ id: id, wmode: wmode });
  }

  /**
   * It takes a div element, toggle it for full screen and set rowHeight for the Video Grid.
   */
  async fullScreen() {
    var elmnt: any;
    this.gridFullScreen = !this.gridFullScreen;
    elmnt = document.getElementById('parentGridLiveView');
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      if (elmnt.requestFullscreen) {
        await elmnt.requestFullscreen();
      } else if (elmnt.webkitRequestFullscreen) {
        await elmnt.webkitRequestFullscreen();
      }
      //console all attributes of elmnt
      for (var i = 0; i < elmnt.attributes.length; i++) {
        console.log(
          elmnt.attributes[i].name + ' = ' + elmnt.attributes[i].value
        );
      }
    } else {
      if (document.exitFullscreen) {
        await document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        await document.webkitExitFullscreen();
      }
    }
    this.rowHeight =
      document.getElementById('parentGrid').offsetWidth / this.Cols +
      ':' +
      document.getElementById('parentGrid').offsetHeight / this.Rows;
  }

  /**
   * "The function resizes the grid based on the width and height of the parent container."
   */
  resizeGrid() {
    try {
      var width = parseInt(
        document.getElementById('parentGridLiveView').offsetWidth
      );
      var height =
        parseInt(document.getElementById('parentGridLiveView').offsetHeight) -
        28;
      this.rowHeight = width / this.Cols + ':' + height / this.Rows;
    } catch (e) {
      console.log(e);
    }
  }
}
